<div class="billing-address-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">{{ 'company_billing_address' | translate }}</h2>
        <button mat-icon-button class="close-button" [mat-dialog-close]="null">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    
    <form [formGroup]="addressForm" class="dialog-content">
        <div class="form-field">
            <label class="field-label">{{ 'company_name' | translate }} <span class="required">*</span></label>
            <input type="text" formControlName="companyName" class="field-input bg-gray-100" autocomplete="off" readonly>
            <span class="field-hint">{{ 'synced_from_legal_business_name' | translate }}</span>
        </div>
        
        <div class="form-field">
            <label class="field-label">{{ 'country' | translate }} <span class="required">*</span></label>
            <mat-select formControlName="country" class="field-input bg-gray-100" [compareWith]="compareCountry" disabled>
                <mat-option *ngFor="let country of data.countries" [value]="country.name">
                    {{ data.translateHelper.localize(country.name) }}
                </mat-option>
            </mat-select>
            <span class="field-hint">{{ 'synced_from_main_country' | translate }}</span>
        </div>
        
        <div class="form-field">
            <label class="field-label">{{ 'city' | translate }} <span class="required">*</span></label>
            <mat-select formControlName="cityId" class="field-input">
                <ng-container *ngIf="selectedCountry && selectedCountry.areas">
                    <mat-optgroup *ngFor="let area of selectedCountry.areas" [label]="data.translateHelper.localize(area.name)">
                        <mat-option 
                            *ngFor="let city of area.cities" 
                            [value]="city._id"
                            (onSelectionChange)="onCitySelect(area._id)">
                            {{ data.translateHelper.localize(city.name) }}
                        </mat-option>
                    </mat-optgroup>
                </ng-container>
            </mat-select>
            <span class="field-error" *ngIf="addressForm.get('cityId').touched && addressForm.get('cityId').invalid">
                {{ 'field_required' | translate }}
            </span>
        </div>
        
        <div class="form-field">
            <label class="field-label">{{ 'street_address' | translate }} <span class="required">*</span></label>
            <input type="text" formControlName="streetAddress" class="field-input" autocomplete="off">
            <span class="field-error" *ngIf="addressForm.get('streetAddress').touched && addressForm.get('streetAddress').invalid">
                {{ 'field_required' | translate }}
            </span>
        </div>
        
        <div class="form-field-row">
            <div class="form-field">
                <label class="field-label">{{ 'building' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="building" class="field-input" autocomplete="off">
                <span class="field-error" *ngIf="addressForm.get('building').touched && addressForm.get('building').invalid">
                    {{ 'field_required' | translate }}
                </span>
            </div>
            
            <div class="form-field">
                <label class="field-label">{{ 'block' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="block" class="field-input" autocomplete="off">
                <span class="field-error" *ngIf="addressForm.get('block').touched && addressForm.get('block').invalid">
                    {{ 'field_required' | translate }}
                </span>
            </div>
        </div>
        
        <div class="form-field-row">
            <div class="form-field">
                <label class="field-label">{{ 'flat' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="flat" class="field-input" autocomplete="off">
                <span class="field-error" *ngIf="addressForm.get('flat').touched && addressForm.get('flat').invalid">
                    {{ 'field_required' | translate }}
                </span>
            </div>
            
            <div class="form-field">
                <label class="field-label">{{ 'road' | translate }} <span class="required">*</span></label>
                <input type="text" formControlName="road" class="field-input" autocomplete="off">
                <span class="field-error" *ngIf="addressForm.get('road').touched && addressForm.get('road').invalid">
                    {{ 'field_required' | translate }}
                </span>
            </div>
        </div>
        
        <div class="form-field">
            <label class="field-label">{{ 'postal_code' | translate }} <span class="required">*</span></label>
            <input type="text" formControlName="postalCode" class="field-input" autocomplete="off">
            <span class="field-error" *ngIf="addressForm.get('postalCode').touched && addressForm.get('postalCode').invalid">
                {{ 'field_required' | translate }}
            </span>
        </div>
    </form>
    
    <div class="dialog-actions">
        <button class="btn-secondary" [mat-dialog-close]="null">
            <mat-icon>close</mat-icon>
            {{ 'cancel' | translate }}
        </button>
        <button class="btn-primary" (click)="saveAddress()" [disabled]="addressForm.invalid">
            <mat-icon>check</mat-icon>
            {{ 'save' | translate }}
        </button>
    </div>
</div>
